import type { SelectProps } from "ant-design-vue";
import type { RegexPassword, RegisterMetaTitle } from "./type";

const positionOptions: SelectProps["options"] = [
  {
    id: 1,
    key: "proposer-option-0",
    value: "ประธานกรรมการสรรหา",
    label: "ประธานกรรมการสรรหา",
  },
  {
    id: 2,
    key: "proposer-option-1",
    value: "กรรมการสรรหา",
    label: "กรรมการสรรหา",
  },
];

const nhrcPositionOptions: SelectProps["options"] = [
  {
    id: 3,
    key: "proposer-option-0",
    value: "ไม่ระบุ",
    label: "ไม่ระบุ",
  },
  {
    id: 1,
    key: "proposer-option-1",
    value: "ประธานกรรมการสรรหา",
    label: "ประธานกรรมการสรรหา",
  },
  {
    id: 2,
    key: "proposer-option-2",
    value: "กรรมการสรรหา",
    label: "กรรมการสรรหา",
  },
];

const registerMetaTitle: RegisterMetaTitle = {
  ec: "กรรมการการเลือกตั้ง",
  nhrc: "กรรมการสิทธิมนุษยชนแห่งชาติ",
  sao: "กรรมการตรวจเงินแผ่นดิน",
  nacc: "กรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ",
  om: "ผู้ตรวจการแผ่นดิน",
  cct: "ศาลรัฐธรรมนูญ",
  nbtc: "กรรมการกิจการกระจายเสียงกิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ",
  pmec: "กรรมการติดตามและประเมินผลการปฏิบัติงาน",
};

const regexPassword: RegexPassword = {
  lowercase: /(?=.*?[a-z]){1,}/,
  uppercase: /(?=.*?[A-Z]){1,}/,
  digital: /(?=.*?[0-9]){1,}/,
  special: /(?=.*?[!@#$%^&*])/,
};

export {
  nhrcPositionOptions,
  positionOptions,
  regexPassword,
  registerMetaTitle,
};
